import { createFileRoute } from "@tanstack/react-router";
import { AdminPageHeader } from "@/components/admin/AdminPageHeader";
import { MediaBrowser } from "@/components/admin/MediaLibrary";

export const Route = createFileRoute("/_admin/admin/media")({
  component: AdminMediaPage,
});

function AdminMediaPage() {
  return (
    <div className="flex min-h-0 flex-col gap-4">
      <AdminPageHeader
        title="Media Library"
        description="One home for every image used on the website. Upload, replace, rename or delete assets here, then reuse them from any image field in the admin."
      />
      <MediaBrowser mode="manage" />
    </div>
  );
}
